// @ts-nocheck
import React, { useState } from 'react';

/**
 * Tooltip — lightweight CSS-positioned tooltip. Pure hover/focus; no portal
 * (so it inherits ancestor stacking context — keep that in mind near modals).
 */
const Tooltip = ({ content, side = 'top', children, className = '' }) => {
  const [open, setOpen] = useState(false);
  const pos = {
    top: { bottom: 'calc(100% + 6px)', left: '50%', transform: 'translateX(-50%)' },
    bottom: { top: 'calc(100% + 6px)', left: '50%', transform: 'translateX(-50%)' },
    left: { right: 'calc(100% + 6px)', top: '50%', transform: 'translateY(-50%)' },
    right: { left: 'calc(100% + 6px)', top: '50%', transform: 'translateY(-50%)' },
  }[side];

  return (
    <span
      className={['relative inline-flex', className].join(' ')}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
    >
      {children}
      {open && content && (
        <span
          role="tooltip"
          className="absolute z-40 whitespace-nowrap pointer-events-none"
          style={{
            ...pos,
            background: 'var(--mov-tooltip-bg)',
            color: 'var(--mov-tooltip-fg)',
            padding: '6px 10px',
            borderRadius: 7,
            fontSize: 12,
            boxShadow: '0 6px 16px -8px rgba(0,0,0,.4)',
          }}
        >
          {content}
        </span>
      )}
    </span>
  );
};

export default Tooltip;
